module.exports = __webpack_public_path__ + "img/vip.8927dc8.svg";